import { setAuthorization } from "./general";
import axios from 'axios';

export function login(credentials) {
  return new Promise((res, rej) => {
    axios.post('/auth/login', credentials)
      .then((response) => {
        setAuthorization(response.data.access_token)
        res(response.data)
      }).catch((err) => {
        let message = 'Desculpe, algo deu errado. Tente novamente mais tarde.'
        if (err.response.status !== 500) {
          message = err.response.data.error
        }
        rej(message)
      })
  })
}

export function getLocalUser() {
  const userStr = localStorage.getItem("user")

  if (!userStr) {
    return null;
  }

  return JSON.parse(userStr);
}
